<template>
    <div class="account-wrap">
        <div class="container">
            <!-- 顶部快捷操作栏 -->
            <!--<div class="quick-bar">
                <div class="bar-title">账户信息</div>
                <div class="btn-group">
                    <el-button type="primary" @click="$router.push('/recharge')"
                        >账户充值</el-button
                    >
                    <el-button @click="$router.push('/finance/home')"
                        >财务管理</el-button
                    >
                    <el-button @click="$router.push('/finance/detail')"
                        >财务明细</el-button
                    >
                </div>
            </div>-->

            <div class="content-row">
                <!-- 左侧主信息区域 -->
                <div class="left-column">
                    <!-- 账户基础信息 -->
                    <div class="info-card">
                        <div class="card-head">
                            <div class="card-title">基础账户信息</div>
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <label>账户名称</label>
                                <span>{{ userInfo?.company_name || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>账户编号</label>
                                <span>{{ userInfo?.id || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>账户状态</label>
                                <span>
                                    <el-tag
                                        :type="
                                            getStatusInfo(
                                                userInfo?.company_static
                                            ).type
                                        "
                                    >
                                        {{
                                            getStatusInfo(
                                                userInfo?.company_static
                                            ).label
                                        }}
                                    </el-tag>
                                </span>
                            </div>
                            <div class="info-item">
                                <label>注册时间</label>
                                <span>{{ userInfo?.createTime || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>绑定手机</label>
                                <span>{{
                                    userInfo?.company_mobile || "-"
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 联系人信息 -->
                    <!-- <div class="info-card">
                        <div class="card-head">
                            <div class="card-title">业务联系人</div>
                            <el-button
                                type="primary"
                                text
                                @click="openContactDialog"
                                >编辑联系人</el-button
                            >
                        </div>
                        <div class="info-list">
                            <div class="info-item">
                                <label>联系人姓名</label>
                                <span>{{ contactInfo.name || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>联系电话</label>
                                <span>{{ contactInfo.phone || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>联系邮箱</label>
                                <span>{{ contactInfo.email || "-" }}</span>
                            </div>
                            <div class="info-item">
                                <label>通讯地址</label>
                                <span>{{ contactInfo.address || "-" }}</span>
                            </div>
                        </div>
                    </div>-->

                    <!-- 企业资质信息 -->
                    <!--
                    <div class="info-card">
                        
                        <div class="card-head">
                            <div class="card-title">企业资质资料</div>
                        </div>
                        <div class="cert-row">
                            <div class="cert-item">
                                <div class="cert-label">营业执照</div>
                                <el-button
                                    text
                                    type="primary"
                                    @click="previewFile('license')"
                                    >预览</el-button
                                >
                            </div>
                            <div class="cert-item">
                                <div class="cert-label">授权委托书</div>
                                <el-button
                                    text
                                    type="primary"
                                    @click="previewFile('auth')"
                                    >预览</el-button
                                >
                            </div>
                        </div>
                        <div class="tip-text">
                            如需更新资质文件，请联系运营客服进行资料替换。
                        </div>
                    </div>-->
                </div>

                <!-- 右侧额度 & 安全 -->
                <div class="right-column">
                    <!-- 额度概况卡片 -->
                    <!--
                    <div class="info-card quota-card">
                        <div class="card-head">
                            <div class="card-title">额度概况</div>
                        </div>
                        <div class="quota-item">
                            <div class="quota-label">账户可用余额</div>
                            <div class="quota-value">
                                ¥{{ quotaData.balance }}
                            </div>
                        </div>
                        <div class="quota-item">
                            <div class="quota-label">当日调用上限</div>
                            <div class="quota-value">
                                {{ quotaData.dayLimit }} 次
                            </div>
                        </div>
                        <div class="quota-item">
                            <div class="quota-label">今日已消耗</div>
                            <div class="quota-value consume">
                                {{ quotaData.dayUsed }} 次
                            </div>
                        </div>
                        <div class="quota-item">
                            <div class="quota-label">余额预警阈值</div>
                            <div class="quota-value warn">
                                ¥{{ quotaData.warningThreshold }}
                            </div>
                        </div>
                        <div class="quota-tip">
                            <span class="dot"></span>
                            余额低于阈值将触发消息提醒，可前往财务管理页面修改阈值
                        </div>
                    </div>-->

                    <!-- 账户安全 -->
                    <!--
                    <div class="info-card">
                        <div class="card-head">
                            <div class="card-title">账户安全</div>
                        </div>
                        <div class="security-row">
                            <div class="security-item">
                                <div class="sec-label">登录密码</div>
                                <el-button
                                    text
                                    type="primary"
                                    @click="openPwdDialog"
                                    >修改密码</el-button
                                >
                            </div>
                            <div class="security-item">
                                <div class="sec-label">上次登录时间</div>
                                <span>{{
                                    accountInfo.lastLoginTime || "-"
                                }}</span>
                            </div>
                            <div class="security-item">
                                <div class="sec-label">上次登录IP</div>
                                <span>{{
                                    accountInfo.lastLoginIp || "-"
                                }}</span>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>

        <!-- 编辑联系人弹窗 -->
        <el-dialog
            v-model="contactDialogVisible"
            title="编辑业务联系人"
            width="500px"
        >
            <el-form :model="contactForm" label-width="100px">
                <el-form-item label="联系人姓名">
                    <el-input
                        v-model="contactForm.name"
                        placeholder="请输入姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input
                        v-model="contactForm.phone"
                        placeholder="请输入手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系邮箱">
                    <el-input
                        v-model="contactForm.email"
                        placeholder="请输入邮箱"
                    ></el-input>
                </el-form-item>
                <el-form-item label="通讯地址">
                    <el-input
                        v-model="contactForm.address"
                        type="textarea"
                        rows="3"
                    ></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="contactDialogVisible = false"
                    >取消</el-button
                >
                <el-button type="primary" @click="saveContact">保存</el-button>
            </template>
        </el-dialog>

        <!-- 修改密码弹窗 -->
        <el-dialog
            v-model="pwdDialogVisible"
            title="修改登录密码"
            width="460px"
        >
            <el-form :model="pwdForm" label-width="100px">
                <el-form-item label="原密码">
                    <el-input v-model="pwdForm.oldPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input v-model="pwdForm.newPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input
                        v-model="pwdForm.confirmPwd"
                        show-password
                    ></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="pwdDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="updatePassword"
                    >确认修改</el-button
                >
            </template>
        </el-dialog>
    </div>
</template>
  
  <script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
// import api from '@/api/api'
const userInfo = ref();

// 账户状态映射
const statusMap = {
    1: { label: "用户正常", type: "success" },
    2: { label: "未补充资质", type: "warning" },
    3: { label: "暂停服务", type: "info" },
    4: { label: "注销", type: "danger" },
};
// 获取当前状态配置
const getStatusInfo = (val) =>
    statusMap[val] || { label: "未知状态", type: "default" };

// ========== 账户基础信息 ==========

const accountInfo = reactive({
    accountName: "吉林数智控股有限公司",
    accountNo: "ACC202605120001",
    status: "normal",
    createTime: "2026-05-12 14:30:22",
    username: "jlszhold",
    lastLoginTime: "2026-07-25 09:42:11",
    lastLoginIp: "119.XX.XX.XXX",
});

// 联系人信息
const contactInfo = reactive({
    name: "张春宇",
    phone: "138XXXX8888",
    email: "admin@jlszhold.com",
    address: "吉林省长春市朝阳区XX大厦",
});

// 额度信息
const quotaData = reactive({
    balance: 16850,
    dayLimit: 230,
    dayUsed: 10,
    warningThreshold: 5000,
});

// 弹窗控制
const contactDialogVisible = ref(false);
const contactForm = reactive({ ...contactInfo });

const pwdDialogVisible = ref(false);
const pwdForm = reactive({
    oldPwd: "",
    newPwd: "",
    confirmPwd: "",
});

// 打开编辑联系人
const openContactDialog = () => {
    Object.assign(contactForm, contactInfo);
    contactDialogVisible.value = true;
};

// 保存联系人
const saveContact = async () => {
    // await api.saveContact(contactForm)
    Object.assign(contactInfo, contactForm);
    contactDialogVisible.value = false;
    ElMessage.success("联系人信息保存成功");
};

// 修改密码弹窗
const openPwdDialog = () => {
    pwdForm.oldPwd = "";
    pwdForm.newPwd = "";
    pwdForm.confirmPwd = "";
    pwdDialogVisible.value = true;
};

// 提交修改密码
const updatePassword = async () => {
    if (!pwdForm.oldPwd || !pwdForm.newPwd) {
        ElMessage.warning("请填写完整密码信息");
        return;
    }
    if (pwdForm.newPwd !== pwdForm.confirmPwd) {
        ElMessage.warning("两次新密码不一致");
        return;
    }
    // await api.changePassword(pwdForm)
    pwdDialogVisible.value = false;
    ElMessage.success("密码修改成功，请重新登录");
};

// 文件预览
const previewFile = (type) => {
    ElMessage.info(
        `预览文件：${type === "license" ? "营业执照" : "授权委托书"}`
    );
    // 可接入图片/pdf预览弹窗
};

onMounted(() => {
    userInfo.value = JSON.parse(localStorage.getItem("user"));
    console.log(userInfo.value);
    // 页面加载获取账户信息
    // const res = await api.getAccountInfo()
});
</script>
  
  <style lang="scss" scoped>
.account-wrap {
    width: 100%;
    min-height: 100vh;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
        "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
    background: radial-gradient(
            1200px 600px at 10% -10%,
            #e8efff 0%,
            transparent 60%
        ),
        radial-gradient(900px 500px at 110% 110%, #f0eaff 0%, transparent 55%),
        linear-gradient(180deg, #f7f9ff 0%, #eef2fb 100%);

    .container {
        max-width: 1400px;
        margin: 0 auto;
    }

    .quick-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #ffffff;
        border-radius: 16px;
        padding: 18px 24px;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04),
            0 12px 32px -12px rgba(16, 24, 40, 0.12),
            0 32px 64px -32px rgba(43, 91, 255, 0.18);
        margin-bottom: 20px;
        .bar-title {
            font-size: 20px;
            font-weight: 600;
            color: #111827;
        }
        .btn-group {
            display: flex;
            gap: 12px;
        }
    }

    .content-row {
        display: grid;
        grid-template-columns: 1fr 340px;
        gap: 20px;
    }

    .left-column {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .right-column {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .info-card {
        background: #ffffff;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04),
            0 12px 32px -12px rgba(16, 24, 40, 0.12),
            0 32px 64px -32px rgba(43, 91, 255, 0.18);

        .card-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 16px;
            border-bottom: 1px solid #eef0f5;
            margin-bottom: 16px;
            .card-title {
                font-size: 16px;
                font-weight: 600;
                color: #111827;
            }
        }
    }

    .info-list {
        .info-item {
            display: flex;
            padding: 10px 0;
            label {
                flex: 0 0 130px;
                color: #6b7280;
            }
            span {
                flex: 1;
                color: #1f2937;
            }
        }
    }

    .cert-row {
        display: flex;
        gap: 32px;
        margin-bottom: 12px;
        .cert-item {
            display: flex;
            align-items: center;
            gap: 12px;
            .cert-label {
                color: #374151;
            }
        }
    }
    .tip-text {
        font-size: 12px;
        color: #9ca3af;
    }

    // 额度卡片
    .quota-card {
        .quota-item {
            display: flex;
            justify-content: space-between;
            padding: 12px 0;
            border-bottom: 1px solid #f3f4f6;
            &:last-of-type {
                border-bottom: none;
            }
            .quota-label {
                color: #6b7280;
                font-size: 14px;
            }
            .quota-value {
                font-size: 16px;
                font-weight: 600;
                color: #111827;
                &.consume {
                    color: #de1c2c;
                }
                &.warn {
                    color: #f59e0b;
                }
            }
        }
        .quota-tip {
            margin-top: 16px;
            padding-top: 12px;
            border-top: 1px solid #f3f4f6;
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            color: #4b5563;
            .dot {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #22c55e;
                box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
                flex-shrink: 0;
            }
        }
    }

    .security-row {
        .security-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            .sec-label {
                color: #6b7280;
            }
            span {
                color: #1f2937;
            }
        }
    }
}

@media (max-width: 1024px) {
    .content-row {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 720px) {
    .account-wrap {
        padding: 12px;
    }
    .quick-bar {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    .info-list .info-item {
        flex-direction: column;
        label {
            margin-bottom: 4px;
        }
    }
}
</style>
  